export const stripTimestamp = (filename: string): string => {
  // Remove timestamp prefix pattern like "1234567890_" from filename
  return filename.replace(/^\d+_/, '');
};

  import { Badge } from "../components/ui/badge";
import { Card, CardContent } from '../components/ui/card';
  export const getStatusBadge = (status: string) => {
    switch (status) {
      case "active":
        return (
          <Badge className="bg-bits-completed rounded-full text-bits-green text-xs px-2 py-1">
            Active
          </Badge>
        );
      case "completed":
        return (
          <Badge className="bg-bits-blue/10 rounded-full text-bits-blue text-xs px-2 py-1">
            Completed
          </Badge>
        );
      case "draft":
        return (
          <Badge className="bg-muted rounded-full text-bits-grey-600 text-xs px-2 py-1">
            Draft
          </Badge>
        );
      default:
        return (
          <Badge variant="outline" className="text-xs px-2 py-1">
            {status}
          </Badge>
        );
    }
  };

 export const getDifficultyBadge = (difficulty: string) => {
    switch (difficulty) {
      case "beginner":
        return (
          <Badge className="bg-bits-completed rounded-full text-bits-green text-xs px-2 py-1">
            Beginner
          </Badge>
        );
      case "intermediate":
        return (
          <Badge className="bg-bits-blue rounded-full text-white text-xs px-2 py-1">
            Intermediate
          </Badge>
        );
      case "advanced":
        return (
          <Badge className="bg-bits-red rounded-full text-white text-xs px-2 py-1">
            Advanced
          </Badge>
        );
      default:
        return (
          <Badge variant="outline" className="text-xs px-2 py-1">
            {difficulty}
          </Badge>
        );
    }
  };

  
 export const StatCard = ({ title, value }: { title: string; value: string | number }) => (
    <Card className="border border-border">
      <CardContent className="p-6">
        <div className="text-3xl font-bold text-bits-blue-neutral-900  mb-1">
          {value}
        </div>
        <div className="text-sm text-bits-grey-600">{title}</div>
      </CardContent>
    </Card>
  );

  